import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  'menu.login': '登录页',
  'pages.layouts.userLayout.title': '生煎唱片旗下版税结算平台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.mailLogin.tab': '邮箱登录',
  'pages.login.username.required': '请输入用户名',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '请输入密码！',
  'pages.login.email.placeholder': '邮箱',
  'pages.login.email.required': '请输入邮箱',
  'pages.login.email.invalid': '邮箱格式错误！',
  'pages.login.captcha.placeholder': '请输入验证码',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.login.captcha.required': '请输入验证码！',
  'pages.login.failure': '账户或密码错误',
  'pages.login.success': '登录成功！',
  'pages.login.failure.retry': '登录失败，请重试！',
  'pages.welcome.title': "欢迎使用 Farfardisc",
  'pages.welcome.subtitle': "请点击左边菜单进行操作",

  'pages.contract.contractName': '结算合集名称',
  'pages.contract.contractId': '结算合集ID',
  'pages.contract.artistName': '艺人名称',
  'pages.contract.shareRate': '分成比例',
  'pages.contract.contractStartTime': '开始日期',
  'pages.contract.contractEndTime': '结束日期',
  'pages.contract.status': '状态',
  'pages.contract.active': '有效',
  'pages.contract.expired': '过期',
  'pages.contract.disabled': '作废',
  'pages.contract.hide': '隐藏',
  'pages.contract.draft': '草稿',
  'pages.contract.form.save.draft': '存草稿',
  'pages.contract.pendingPayment': '结算合集待付款￥',
  'pages.contract.pendingPayment.tooltip': '如果为正数则代表需要向艺人支付，负数代表已预付金额。报告只有经过艺人确认才会计入结算合集待付款。',
  'pages.contract.actions': '操作',
  'pages.contract.edit': '编辑',
  'pages.contract.view': '查看',
  'pages.contract.refresh': '刷新',
  'pages.contract.contractName.placeholder': '结算合集名称',
  'pages.contract.artistName.placeholder': '艺人名称',
  'pages.contract.selectStatus': '选择状态',
  'pages.contract.all': '全部',

  'pages.albumContract.distributorName': '经销商名称',
  'pages.albumContract.distributorName.placeholder': '经销商名称',

  'pages.report.details.title': '报告涵盖时间',
  'pages.report.details.country.title': '国家/地区收益表',
  'pages.report.details.platform.title': '平台收益表',
  'pages.report.details.profit.title': '歌曲收益表',
  'pages.report.details.profit.album.title': '实体收益表',
  'pages.report.details.discount.album.title': '销售折扣',
  'pages.report.details.balance.title': '余额变更',
  'pages.report.details.balance.change': '余额变更￥',
  'pages.report.details.balance.comment': '备注',
  'pages.report.details.balance.confirm': '确认余额变更',
  'pages.report.details.balance.confirm.content': '您确定要添加余额变更 ￥{balance} 吗？',
  'pages.report.details.balance.cancel': '取消余额变更',
  'pages.report.details.balance.success': '余额变更成功！',
  'pages.report.details.balance.error': '余额变更失败',
  'pages.report.details.confirm.report': '确认报告',
  'pages.report.details.confirm.report.content': '您要确定报告吗？',
  'pages.report.details.delete.report': '删除报告',
  'pages.report.details.delete.success': '删除成功',
  'pages.report.details.delete.report.content': '您确定要删除报告吗？',
  'pages.report.details.confirm.success': '确认成功, 将在稍后更新',
  'pages.report.details.confirm.error': '确认失败',
  'pages.report.details.confirm.cancel': '取消确认报告',
  'pages.report.details.country': '国家',
  'pages.report.details.platform': '平台',
  'pages.report.details.song.title': '歌曲名',
  'pages.report.details.song.isrc': 'ISRC',
  'pages.report.details.album.id': '实体ID',
  'pages.report.details.album.name': '实体名称',
  'pages.report.details.salesAmount': '销售金额',
  'pages.report.details.distributionDiscount': '分销折扣',
  'pages.report.details.net.profit': '净利润',
  'pages.report.details.net.profit.artist': '艺人净利润',
  'pages.report.details.play.count': '播放/使用次数',
  'pages.report.details.sale.count': '销售/使用数量',

  'pages.report.details.add.balance': '添加余额变更',
  'pages.report.details.operation': '操作',
  'pages.report.details.edit': '编辑',
  'pages.report.details.delete': '删除',
  'pages.report.details.confirm': '确认',
  'pages.report.details.error': '失败',
  'pages.report.details.tooltip': '正数代表需要付给艺人，负数代表需要向艺人扣除。',


  'pages.contract.report.page.title': '报告页面',
  'pages.contract.report.page.download.excel': '下载Excel详细报表',
  'pages.contract.report.page.download.pdf': '下载PDF结算单',
  'pages.contract.report.page.download.sales.list': '下载报告相关销售记录',
  'pages.contract.report.page.send.report': '发送报告',
  'pages.contract.report.page.confirm.report': '确认报告',
  'pages.contract.report.page.pay.report': '打款',
  'pages.contract.report.page.pay.contract': '打款',
  'pages.contract.report.page.refresh': '刷新',
  'pages.contract.report.page.unsent': '未发送',
  'pages.contract.report.page.sent': '已发送',
  'pages.contract.report.page.read': '已查阅',
  'pages.contract.report.page.confirmed': '已确认',
  'pages.contract.report.page.paid': '已打款',
  'pages.contract.report.page.unpaid': '未打款',
  'pages.contract.report.page.view': '查看',
  'pages.contract.report.page.download': '下载',
  'pages.contract.report.page.artist.short.id': '艺人编号',
  'pages.contract.report.page.artist.name': '艺人姓名',
  'pages.contract.report.page.contract.start.date': '结算合集开始日期',
  'pages.contract.report.page.contract.end.date': '结算合集结束日期',
  'pages.contract.report.page.contract.balance': '结算合集待打款￥',
  'pages.contract.report.page.contract.balance.tooltip': '如果为正数则代表需要向艺人支付，负数代表已预付金额。报告只有经过艺人确认才会计入待打款。',
  'pages.contract.report.page.report.status': '报告状态',
  'pages.contract.report.page.net.profit': '销售金额',
  'pages.contract.report.page.net.profit.artist': '艺人净利润',
  'pages.contract.report.page.net.profit.artist.statement': '已扣除所有抵扣项（例如制作成本）',

  'pages.contract.report.page.start.time': '开始时间',
  'pages.contract.report.page.end.time': '结束时间',
  'pages.contract.report.page.generate.time': '生成时间',
  'pages.contract.report.page.is.paid': '是否打款',
  'pages.contract.report.page.action': '操作',
  'pages.contract.report.page.download.disabled': '导出中，稍后会自动下载',
  'pages.contract.report.page.download.success': '报告下载成功',
  'pages.contract.report.page.download.error': '报告下载失败',
  'pages.contract.report.page.send.success': '发送成功',
  'pages.contract.report.page.send.error': '发送失败',
  'pages.contract.report.page.confirm.success': '确认成功, 将在稍后更新',
  'pages.contract.report.page.confirm.error': '确认失败',
  'pages.contract.report.page.pay.success': '打款成功, 将在稍后更新',
  'pages.contract.report.page.pay.error': '打款失败',
  'pages.contract.report.page.cancel': '取消',
  'pages.contract.report.page.per.page': '每页显示数量',
  'pages.contract.report.page.per.page.option': '每页 {size} 条',
  'pages.contract.report.page.artist.confirm': '确认',
  'pages.contract.report.page.artist.delete': '删除',
  'pages.contract.report.page.artist.sent': '待确认',

  "pages.contract.artist.short.id": "艺人编号",
  "pages.contract.artist.name": "艺人姓名",
  "pages.contract.contract.start.date": "开始时间",
  "pages.contract.contract.end.date": "结束时间",

  'pages.contract.form.contractName': '结算合集名称',
  'pages.contract.form.contractName.placeholder': '请输入结算合集名称',
  'pages.contract.form.artistName': '艺人名称',
  'pages.contract.form.artistName.placeholder': '请输入艺人名称',
  'pages.contract.form.artistEmail': '艺人邮箱',
  'pages.contract.form.artistEmail.placeholder': '请输入艺人邮箱',
  'pages.contract.form.contractStartTime': '结算合集开始日期',
  'pages.contract.form.contractStartTime.placeholder': '请选择结算合集开始日期',
  'pages.contract.form.contractEndTime': '结算合集结束日期',
  'pages.contract.form.contractEndTime.placeholder': '请选择结算合集结束日期',
  'pages.contract.form.contractShareRate': '结算合集分成比例',
  'pages.contract.form.contractShareRate.placeholder': '请输入小数，如0.3 代表30%',
  'pages.contract.form.contractStatus': '结算合集状态',
  'pages.contract.form.contractStatus.placeholder': '请选择结算合集状态',
  'pages.contract.form.contractComment': '备注',
  'pages.contract.form.contractComment.placeholder': '请输入备注',
  'pages.contract.form.contractPayType': '收款方式',
  'pages.contract.form.contractPayType.placeholder': '请选择收款方式',
  'pages.contract.form.contractPayAccount': '收款账号',
  'pages.contract.form.contractPayAccount.placeholder': '请输入收款账号',
  'pages.contract.form.contractPayName': '收款姓名',
  'pages.contract.form.contractPayName.placeholder': '请输入收款姓名',
  'pages.contract.form.contractPayOpenBank': '开户行',
  'pages.contract.form.contractPayOpenBank.placeholder': '请输入开户行',
  'pages.contract.form.contractPrePay': '预付款',
  'pages.contract.form.contractPrePay.placeholder': '请输入预付款，例如200代表预付200元',
  'pages.contract.form.contractBalance': '待打款金额',
  'pages.contract.form.artifactList.title': '结算合集相关歌曲列表',
  'pages.contract.form.artifact.isrc': '歌曲ISRC',
  'pages.contract.form.artifact.isrc.placeholder': '请输入歌曲ISRC',
  'pages.contract.form.artifact.songId': '歌曲ID',
  'pages.contract.form.artifact.songId.placeholder': '请输入歌曲ID',
  'pages.contract.form.artifact.name': '歌曲名称',
  'pages.contract.form.artifact.name.placeholder': '请输入歌曲名称',
  'pages.contract.form.artifact.edit': '编辑',
  'pages.contract.form.artifact.delete': '删除',
  'pages.contract.form.artifact.error.required': '至少添加一首相关歌曲！',
  'pages.contract.form.artifact.error.nameEmpty': '歌曲名称不能为空！',
  'pages.contract.form.artifact.error.isrcOrIdRequired': '歌曲ISRC和歌曲ID至少填一个！',

  'pages.contract.form.confirm.title': '结算合集信息确认',
  'pages.contract.form.confirm.message': '请核对结算合集的详细信息：',

  'pages.contract.form.save.success': '结算合集保存成功！',
  'pages.contract.form.save.draft.success': '结算合集草稿保存成功！',
  'pages.contract.form.contractName.required': '请输入结算合集名称',
  'pages.contract.form.artistName.required': '请输入艺人名称',
  'pages.contract.form.artistEmail.required': '请输入艺人邮箱',
  'pages.contract.form.contractStartTime.required': '请选择结算合集开始日期',
  'pages.contract.form.contractEndTime.required': '请选择结算合集结束日期',
  'pages.contract.form.contractShareRate.required': '请输入结算合集分成比例',
  'pages.contract.form.contractStatus.required': '请选择结算合集状态',
  'pages.contract.form.contractPayType.required': '请选择付款方式',
  'pages.contract.form.contractPayAccount.required': '请输入付款账号',
  'pages.contract.form.contractPayName.required': '请输入付款姓名',
  'pages.contract.form.contractPayOpenBank.required': '请输入开户行',
  'pages.contract.form.contractPrePay.required': '请输入预付款',
  'pages.contract.form.contractBalance.required': '请输入预付款',
  'pages.contract.form.artifactList.noArtifacts': '暂无相关歌曲',
  'pages.contract.form.contractPayType.alipay': '支付宝',
  'pages.contract.form.contractPayType.bank': '银行账号',

  'pages.title.welcome': "欢迎页面",
  'pages.title.contractManage': "线上结算合集管理",
  'pages.title.contractList': "线上结算合集列表",
  'pages.title.draft.contractList': "线上结算合集草稿列表",
  'pages.title.contractListArtist': "已签署的结算合集查看",
  "pages.title.reportManage": "报表管理",
  "pages.title.reportDetails": "线上销售报表详情",
  "pages.title.reportDetailsArtist": "版税报表查看",

  'pages.title.albumContractManage': "实体销售合同管理",
  'pages.title.albumContractDraftManage': "实体销售合同草稿管理",
  'pages.title.albumContractAdd': "添加实体销售合同",
  'pages.title.albumReportManage': "实体销售报表详情",


  "global.loading.text": "请求进行中...",

  'pages.title.singleAnnualReport': '线上年终统计报表',
  'pages.title.albumAnnualReport': '实体年终统计报表',
  'pages.annualReport.exportTimeframe': '统计时间范围：',
  'pages.annualReport.exportBtn': '导出报表',
  'pages.annualReport.exporting': '正在提交导出任务...',
  'pages.annualReport.selected': '已选',
  'pages.annualReport.items': '项',
  'pages.annualReport.clear': '清空',
  'pages.annualReport.selectDateRange': '请选择统计时间范围',
  'pages.annualReport.selectContracts': '请选择至少一个合同',
  'pages.annualReport.exportMockSuccess': '后端导出任务已提交！(前端交互已就绪，等待后端接口)',
  'pages.annualReport.exportSuccess': '导出任务处理完毕！',
  'pages.annualReport.exportConfirmTitle': '导出确认',
  'pages.annualReport.exportConfirmContent': '请确认您要导出？',
  'pages.annualReport.downloadTitle': '下载报表',
  'pages.annualReport.close': '关闭',
  'pages.annualReport.downloadBtn': '立即下载',
  'pages.annualReport.downloadContent': '报表已生成，请点击下方按钮下载。',
};
